module.exports = __webpack_public_path__ + "img/unchecked-box.33e4701a.svg";